import Button from 'components/base/Button';
import { useToast } from 'hooks/useToast';
import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { resetInstitution } from 'reducers/AuthReducer';
import { useRegisterInstitutionMutation } from 'service/authQuery/authQuery';
import { RootState } from 'store/rootReducer';

function Verification() {
  const [token, setToken] = useState<string | null>(null);
  const [register, { isLoading }] = useRegisterInstitutionMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { open } = useToast();

  const institution = useSelector(
    (state: RootState) => state.auth.register.institution
  );

  const handleSubmit = () => {
    if (!token) {
      open('Verification has not yet been completed.', 'error');
      return;
    }
    register(institution)
      .unwrap()
      .then(response => {
        const id = response?.data?._id;
        dispatch(resetInstitution());
        navigate(`/verify/sent/institution/${id}`);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const handleRecaptchaChange = (value: string | null) => {
    setToken(value);
  };

  return (
    <>
      <div className="position-relative mt-4">
        <hr className="bg-body-secondary" />
        <div className="divider-content-center">Verification</div>
      </div>
      <div className="mb-3">
        <p className="text-center fw-bold">Prove you’re not a bot</p>
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_CAPTCHA_KEY || ''}
          onChange={handleRecaptchaChange}
          size="normal"
        />
      </div>
      <Button
        variant="primary"
        className="w-100 mb-3"
        onClick={handleSubmit}
        loading={isLoading}
        loadingPosition="start"
        disabled={!token || isLoading}
      >
        Sign Up
      </Button>
    </>
  );
}

export default Verification;
